import React from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';

import { useTheme } from '../context/ThemeContext';
import { borderRadius, spacing } from '../utils/theme';
import type { ColorTheme } from '../utils/theme';

/** Card - themed surface container with shadow elevation. */
interface CardProps {
  readonly children: React.ReactNode;
  readonly style?: StyleProp<ViewStyle>;
}

export default function Card({ children, style }: CardProps) {
  const { colors } = useTheme();
  const styles = useStyles(colors);
  return <View style={[styles.card, style]}>{children}</View>;
}

const createStyles = (c: ColorTheme) => StyleSheet.create({
  card: {
    backgroundColor: c.surface,
    borderRadius: borderRadius.lg,
    padding: spacing.lg,
    shadowColor: c.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 3,
  },
});

const useStyles = (c: ColorTheme) => React.useMemo(() => createStyles(c), [c]);
